/** ShapeCast3D parser: the Node3D transform surface plus the swept shape, `enabled`, `target_position` and the debug colour. */
import { parseOptionalBool } from '../../../../parser/valueParsers';
import { parseColorOrUndefined } from '../../../../utils/colorParser';
import { parseNode3D } from '../../../base/node3d/parser';
import { parseCastTargetPosition } from '../../shared/castTarget';
export function parseShapeCast3D(heading, properties) {
    const result = { ...parseNode3D(heading, properties) };
    const enabled = parseOptionalBool(properties.enabled);
    if (enabled !== undefined)
        result.enabled = enabled;
    if (properties.shape)
        result.shape = properties.shape;
    const targetPosition = parseCastTargetPosition(properties, 'ShapeCast3D');
    if (targetPosition !== undefined)
        result.target_position = targetPosition;
    const customColor = parseColorOrUndefined(properties.debug_shape_custom_color);
    if (customColor)
        result.debug_shape_custom_color = customColor;
    return result;
}
//# sourceMappingURL=parser.js.map